import { InjectionToken } from '@angular/core';

export const SERVER_URL_TOKEN = new InjectionToken<string>('Token containing the absolute request url');
export const NG_API_TIMEOUT_TOKEN = new InjectionToken<number>('Token containing the api timeout value');
export const BUILD_TOKEN = new InjectionToken<string>('Token containing the current build id');
export const APPINSIGHTS_TOKEN = new InjectionToken<string>('Token containing the appinsights instrumentation key');
